import { Platform } from 'react-native';

import { cleverTapConfig } from './clevertap.config';
declare global {
	interface Window {
		clevertap?: any;
	}
}

class CleverTapService {
	private initialized = false;
	private isWebPlatform = Platform.OS === 'web';

	async initialize() {
		if (!this.isWebPlatform || this.initialized) return;

		try {
			await this.loadCleverTapScript();

			if (window.clevertap) {
				window.clevertap.init(`${cleverTapConfig.accountId}, ${cleverTapConfig.region}`);
				window.clevertap.privacy.push({ optOut: false });
				window.clevertap.privacy.push({ useIP: true });

				this.initialized = true;
				console.log('[CleverTap] ✅ Web initialized');
			}
		} catch (error) {
			console.error('[CleverTap] ❌ Init failed:', error);
		}
	}

	private loadCleverTapScript(): Promise<void> {
		return new Promise((resolve, reject) => {
			if (window.clevertap) {
				resolve();
				return;
			}

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = 'https://d2r1yp2w7bby2u.cloudfront.net/js/clevertap.min.js';
			script.onload = () => resolve();
			script.onerror = () => reject(new Error('Failed to load CleverTap script'));
			document.head.appendChild(script);
		});
	}

	async trackEvent(eventName: string, properties?: Record<string, any>) {
		console.log('cleveraaaap event');
		if (!this.initialized || !window.clevertap) {
			console.log(`[CleverTap] Would log: ${eventName}`, properties);
			return;
		}

		try {
			window.clevertap.event.push(eventName, properties);
			console.log(`[CleverTap] 📊 Event: ${eventName}`, properties);
		} catch (error) {
			console.warn(`[CleverTap] Failed to log event ${eventName}:`, error);
		}
	}

	async setUserProfile(profile: Record<string, any>) {
		if (!this.initialized || !window.clevertap) return;

		try {
			window.clevertap.profile.push({
				Site: profile,
			});
			console.log('[CleverTap] 👤 Profile updated:', profile);
		} catch (error) {
			console.warn('[CleverTap] Failed to set profile:', error);
		}
	}
}

export const cleverTapService = new CleverTapService();
